import PropTypes from "prop-types"
import Panel from "../panel"
import { numberFormatter } from "helpers/formatters/numbers"
import { Row } from "../rows"

function ScorecardForecast({ forecast, rebalancedForecast }) {
  return <Panel fixed>
    <Row
      id="return"
      label="Return (%)"
      original={forecast.returnPerc}
      rebalanced={rebalancedForecast.returnPerc}
      delta={rebalancedForecast.returnPerc - forecast.returnPerc}
      formatter={numberFormatter}
      fixed
    />
    <Row
      id="return"
      label="Total Risk (%)"
      original={forecast.total * 100}
      rebalanced={rebalancedForecast.total * 100}
      delta={(rebalancedForecast.total - forecast.total) * 100}
      formatter={numberFormatter}
      fixed
    />
    <Row
      id="return"
      label="Sharpe"
      original={forecast.sharpe}
      rebalanced={rebalancedForecast.sharpe}
      delta={rebalancedForecast.sharpe - forecast.sharpe}
      formatter={numberFormatter}
      fixed
    />
  </Panel>
}

ScorecardForecast.propTypes = {
  forecast: PropTypes.object.isRequired,
  rebalancedForecast: PropTypes.object.isRequired,
}

export default ScorecardForecast
